import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from '../app-config/app-config-service';
import { Observable } from 'rxjs';
import { SearchAccountsRequest } from 'src/app/shared/models/search-accounts-request.model';
import { CustomerAccountsRequest } from 'src/app/shared/models/customer-accounts-request.model';
import { Operation } from 'src/app/shared/models/operation.model';
import { AccountCollection } from 'src/app/shared/models/account-collection';

@Injectable({
  providedIn: 'root'
})
export class UserManagementDataService {

  constructor(
    private httpClient: HttpClient,
    private appConfigService: AppConfigService) {
  }

  getUserData() {
    const apiUrl = 'users/me/profile';
    return this.getData<any>(apiUrl);
  }

  getUserPermission(isInternalUser: boolean) {
    const apiUrl = isInternalUser ? 'users/me/eurofinsLegalEntities' : 'users/me/accounts/permissions';
    return this.getData<any>(apiUrl);
  }

  getAccounts(filter: SearchAccountsRequest): Observable<AccountCollection> {
    const apiUrl = 'accounts/search';
    return this.getDataByFilter<AccountCollection>(apiUrl, filter);
  }

  getCustomerUserAccounts(customerAccountsRequest: CustomerAccountsRequest): Observable<AccountCollection> {
    const apiUrl = 'accounts';
    return this.getDataByAccountCodes<AccountCollection>(apiUrl, customerAccountsRequest);
  }

  getCanViewPricePermission(isInternalUser: boolean, accountCode: string): Observable<Operation> {
    const applicationCode = 'EOL';
    const operationPermissionScope = isInternalUser ? 'Application' : 'Account';
    const operationName = 'CanViewPrices';
    const apiUrl = `applications/${applicationCode}/users/me/operations?operationPermissionScope=${operationPermissionScope}&operationNames=${operationName}&accountCodes=${accountCode}`;
    return this.getData<Operation>(apiUrl);
  }

  getUserApplicationPermissions(applicationCode: string) {
    const apiUrl = 'applications/' + applicationCode + '/users/me/operations';
    return this.getData<any>(apiUrl);
  }

  // Private methods
  private getDataByFilter<T>(apiUrl: string, searchRequest: SearchAccountsRequest): Observable<T> {
    const url = this.appConfigService.configuration.apiConfig.userManagementQueryBaseUrl + apiUrl;
    let sortColumn = searchRequest.sortColumn == '' ? '0' : searchRequest.sortColumn;
    return this.httpClient.get<T>(url, {
      params: {
        sortColumn: sortColumn,
        sortDirection: searchRequest.sortDirection.toString(),
        pageNumber: searchRequest.pageNumber.toString(),
        recordsCount: searchRequest.recordsCount.toString(),
        SearchText: searchRequest.searchText,
        pageSize: searchRequest.pageSize.toString(),
        eleCodes: searchRequest.eleCodes,
      }
    });
  }

  private getDataByAccountCodes<T>(apiUrl: string, customerAccountsRequest: CustomerAccountsRequest): Observable<T> {
    const url = this.appConfigService.configuration.apiConfig.userManagementQueryBaseUrl + apiUrl;
    return this.httpClient.get<T>(url, {
      params: {
        accountCodes: customerAccountsRequest.accountCodes
      }
    });
  }

  private getData<T>(apiUrl: string): Observable<T> {
    const url = this.appConfigService.configuration.apiConfig.userManagementQueryBaseUrl + apiUrl;
    return this.httpClient.get<T>(url);
  }
}
